import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Components/Login';
import Dashboard from './Components/Dashboard';
import Customers from './Components/Customers/Customers';
import Orders from './Components/Orders/Orders';
import Payments from './Components/PaymentDetails/Payments';
import UserProfile from './Components/UserProfile/UserProfile';
import Projects from './Components/Projects/Projects';
import AuthProvider from './context/AuthProvider';
import { PresenceProvider } from './context/PresenceContext';
import PrivateRoute from './context/PrivateRoute';
import DashboardContent from './Components/Dashboard/DashboardContent';
import './Css/style.css';
import './App.css';
import Production from './Components/production/Production';
import ProductionOrders from './Components/production/ProductionOrders';
import PoOrderValidation from './Components/production/PoOrderValidation';
import Warehouse from './Components/warehouse/Warehouse';
import OrderPending from './Components/Orders/OrderPending';
import OrderComplted from './Components/Orders/OrderComplted';
import OrderValidation from './Components/Orders/OrderValidation';
import Historical from './Components/historical/Historical';
// import Company from './Components/Marketing/Companies';
import Contacts from './Components/Marketing/Contacts';
import ConnectToZoho from './Components/Marketing/ConnectToZoho';
import Highlights from './Components/highlights/Highlights';
import Invoices from './Components/Orders/Invoices';
import Quotes from './Components/Orders/Quotes';
import SalesOrdersArchive from './Components/Orders/SalesOrdersArchive';
import PoOrderArchive from './Components/production/PoOrderArchive';
import QuotesArchive from './Components/Orders/QuotesArchive';
import BomPartsArchive from './Components/Orders/BomPartsArchive';
import OrderDetailsPage from './Components/Orders/OrderDetailsPage';
import QuoteDetailsPage from './Components/Orders/QuoteDetailsPage';
import NotificationSettings from './Components/NotificationSettings';
import UserAdminRoute from './Components/UserAdmin/UserAdminRoute';
import './Css/bridge-theme.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public route for login */}
          <Route path="/" element={<Login />} />
          <Route path="*" element={<Login />} />
          {/* Protected Routes */}
          <Route element={<PrivateRoute />}>
            {/* PresenceProvider owns the single presence socket; mounted here so it
                only connects for signed-in users. */}
            <Route element={<PresenceProvider><Dashboard /></PresenceProvider>}>
              <Route path="dashboard" element={<DashboardContent />} />
              <Route path="customers" element={<Customers />} />
              <Route path="order-validation" element={<OrderValidation/>} />
              {/* <Route path="orders" element={<Orders />} /> */}
              <Route path="orders" element={<Orders key={window.location.pathname} />} />
              <Route path="ordersInternal" element={<Orders path="652" />} />
              <Route path="orders-pending" element={<OrderPending/>} />
              <Route path="orders-completed" element={<OrderComplted/>} />
              <Route path="payments" element={<Payments />} />
              <Route path="profile" element={<UserProfile />} />
              <Route path="projects" element={<Projects />} />
              <Route path="po-order-validation" element={<PoOrderValidation/>}/>
              <Route path="receivingproduction" element={<Production/>}/>
              <Route path="production-orders" element={<ProductionOrders/>}/>
              <Route path='warehouse' element={<Warehouse/>}/>
              <Route path='historicaldemand' element={<Historical/>}/>
              {/* <Route path='companies' element={<Company/>}/> */}
              <Route path='contacts' element={<Contacts/>}/>
              <Route path='connecttozoho' element={<ConnectToZoho/>}/>
              <Route path='highlights' element={<Highlights/>}/>
              <Route path='invoces' element={<Invoices/>}/>
              <Route path='quotes' element={<Quotes/>}/>
              <Route path='sales-order-archive' element={<SalesOrdersArchive/>}/>
              <Route path='po-order-archive' element={<PoOrderArchive/>}/>
              <Route path='quotes-archive' element={<QuotesArchive/>}/>
              <Route path='bom-parts-archive' element={<BomPartsArchive/>}/>
              <Route path='order-details/:orderNum' element={<OrderDetailsPage/>}/>
              <Route path='quote-details/:quoteId' element={<QuoteDetailsPage/>}/>
              <Route path='notification-settings' element={<NotificationSettings/>}/>
              {/* User Administration: IT Managers only (checked here and on the server). */}
              <Route path='user-administration' element={<UserAdminRoute tab="users"/>}/>
              <Route path='user-administration/roles' element={<UserAdminRoute tab="roles"/>}/>
              <Route path='user-administration/activity' element={<UserAdminRoute tab="activity"/>}/>
            </Route>
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
